import {getEndpoint, getHeaders} from '../../../helpers/endpoint';

export const REQUEST_FETCH_PLAYER_POOL = 'REQUEST_FETCH_PLAYER_POOL';
export const SUCCESS_FETCH_PLAYER_POOL = 'SUCCESS_FETCH_PLAYER_POOL';
export const FAIL_FETCH_PLAYER_POOL = 'FAIL_FETCH_PLAYER_POOL';

export const fetchPlayerPool = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_PLAYER_POOL, payload, scope});

    fetch(getEndpoint('fetchPlayerPool', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_PLAYER_POOL,
            error: data.error,
            payload,
            scope,
          });
        else
          dispatch({
            type: SUCCESS_FETCH_PLAYER_POOL,
            receivedAt: Date.now(),
            data: data.players,
          });
          payload.onSuccess(data);
      })
      .catch((error, type = FAIL_FETCH_PLAYER_POOL) => {
        dispatch({type, error, payload, scope});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/app/playerPool/index.js